module.exports = __webpack_public_path__ + "static/media/agent_d.b9449703.png";